import React, { useEffect, useState, useContext } from "react";

import cogoToast from "cogo-toast";
import BookList from "../Slider/Slider";
import AuthContext from "../../contexts/AuthContext";

import styles from "./User.module.css";

const Library = ({ title }) => {
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AuthContext);

  const [books, setBooks] = useState([]);
  useEffect(() => {
    if (!loading) return;
    (async () => {
      try {
        const rawResponse = await fetch("https://api.yazbie.com/api/stories", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        });
        try {
          const content = await rawResponse.json();
          const num = () => Math.floor(Math.random() * (0 - 7 + 1) + 7);
          if (content && content.success) {
            setBooks(
              content.stories.map((book) => ({
                ...book,
                coverImage: `/assets/images/Dashboard/book${num()}.png`,
              }))
            );
          }
        } catch (err) {
          cogoToast.error("An error occured");
        }
      } catch (err) {
        cogoToast.error("A network error occured");
        console.log(err);
      }
      setLoading(false);
    })();
  }, [loading, token, books]);
  return (
    <section className={styles.library}>
      {loading || (
        <React.Fragment>
          <h5 className={styles.sectionHeader}>{title}</h5>
          <BookList books={books} />
        </React.Fragment>
      )}
    </section>
  );
};

export default Library;
